module.exports = __webpack_public_path__ + "static/img/business20.132cf49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business20.jpg
// module id = JVCY
// module chunks = 9